import { PageHeaderFilters } from '@src/components/details/components/PageHeaderFilters';
import { ListKeys } from '@src/constants/microcredits';
import type { IFilter } from '@src/hooks/useFilters';
import { isNaKartuPage } from '@src/utils/routing';
import { AmountFilter } from 'features/AmountFilter';
import { PhoneNumberChecker } from 'features/PhoneNumberChecker';

export const getListPageFilterComponent = (path: string, filters: IFilter) => {
  const isNaKartu = isNaKartuPage(path);
  const isMain = path === '/zaimy/';

  if (isNaKartu) {
    return (
      <PageHeaderFilters
        initialAmount={filters.filters.amount}
        initialTerm={filters.filters.term}
        setFilter={filters.setFilter}
      />
    );
  }

  if (isMain) {
    return <PhoneNumberChecker />;
  }

  return <AmountFilter filters={filters} listKey={ListKeys.LIST} />;
};
